import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import DayJs from 'utils/Dayjs';

import Pill from 'components/Misc/Pill';
import Avatar from 'components/Misc/Avatar';
import { Title } from 'components/Misc/Typography';

const className = classnames(
	'py-2 px-3 flex flex-col space-y-2 border-4 rounded-lg cursor-pointer transition-all',
	'dark:border-neutral-800 dark:bg-neutral-800 hover:dark:bg-neutral-900',
	'border-white bg-white hover:bg-neutral-50'
);

const Take = ({ take }) => {
	return (
		<Link to={`/exams/results/review/${take.examId}/${take.id}`} className={className}>
			<div className="flex-1 flex items-center space-x-4">
				<Avatar
					alt={take.student.fullName}
					src={take.student.avatar}
					online={take.student.online}
				/>

				<Title
					title={take.student.fullName}
					subtitle={DayJs(take.endedAt).format('D. MMM, YYYY HH:mm')}
					className="flex-1"
				/>
			</div>

			<Pill name={`${take.exam.subject?.title} - ${take.exam.title}`} />
		</Link>
	);
};

export default Take;